import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import AllGiftCards from './AllGiftCards';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { dateFormatUtil } from '../Utilities';

import { withFirebase } from '../Firebase';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import {
    getStorage,
    ref,
    uploadBytes,
    list,
    getDownloadURL
} from 'firebase/storage';
import styles from './banner_upload.module.scss';
const pageSizes = [5, 10, 25, 50, 100];

const searchBy = [
    { key: 'Slug Name', value: 'name' },
    { key: 'Master GC', value: 'master_gc' }
];


class AllList extends React.Component {
    _isMounted = false;
    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        showGCList:false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'name',
        selectedItem:[],
        DownloadReady:false,
        reportModalShow:false,

        modalShow: false,
        editmode: 'Add',
        alert: 0,
        alertMessage: '',
        data: [],
        selectedRow: [],
        flag: true,
        name:'',
        oldSlug:'',
        master_gc:'',
        monthly_limit:'',
        weight:'',
        slug_banner:'',
        masterGCList:[],
    };
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
        this.loadMasterGiftCards()
    }

    handleImageAsFile = (e) => {
        const file = e.target.files[0];
        const storage = getStorage();
        const fileName = new Date().getTime()
        const storageRef = ref(storage, 'GCBanners/' + fileName);

        uploadBytes(storageRef, file).then(async(snapshot) => {
            await getDownloadURL(ref(storage, 'GCBanners/' + fileName)).then(
                
                async (imageUrl) => {
                    console.log('imageUrl',imageUrl)
                    if (this._isMounted) {
                        this.setState({
                            slug_banner: imageUrl
                        });
                   }
                })
        });
    };

    

    async loadMasterGiftCards() {
        let bodyData = {
            search_key: '',
            search_by: '',
            userRole: 'Admins',
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };
        await RestServices.getAllMasterGiftCards(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (this._isMounted) {
                        this.setState({
                            masterGCList: responseData.list
                        });
                }
                    
            })
            
    }

    async loadData() {
        let bodyData = {
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };
        
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'slugs/all-slugs'
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {

                    this.setState({
                        PrevpageNumber: this.state.pageNumber,
                        PrevStartAt: this.state.StartAt,
                        PrevLastDocument: this.state.LastDocument,
                        PrevFirstDocument: this.state.FirstDocument
                    });

                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.data,
                            flag: false,
                            alert: 0
                        });
                    }
                    
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
        if (event.target.value === ''){
            this.setState({ [event.target.name]: '' });
        }else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    
    

    listGC = (rowData) => {
        if (this._isMounted) {
            this.setState({ showGCList: true, selectedRow: rowData });
        }
    };
    
    hideOffers  = () => {
        if (this._isMounted) {
            this.setState({ showGCList: false,  selectedRow: [] });
        }
    };

    
    
    updateDetail= (item)=>{
        if (this._isMounted) {
        this.setState({master_gc:item.master_gc, oldSlug:item.slug, name:item.name, monthly_limit:item.monthly_limit,weight:item.weight,slug_banner:item.slug_banner, selectedItem:item,editmode:'Edit', modalShow: true });
        }
    } 
    deleteDetail= (item)=>{
        if (this._isMounted) {
        this.setState({selectedItem:item,editmode:'Delete', modalShow: true });
        }
    } 
    
    UpdateConfirmed = () => {
        console.log(this.state)
        let data = {
            name: this.state.name?this.state.name:this.state.selectedItem.name,
            slug: this.state.selectedItem.slug,
            weight:this.state.weight?this.state.weight:this.state.selectedItem.weight,
            monthly_limit:this.state.monthly_limit?this.state.monthly_limit:this.state.selectedItem.monthly_limit,
            master_gc:this.state.master_gc?this.state.master_gc:this.state.selectedItem.master_gc,
            oldSlug:this.state.oldSlug,
            slug_banner: this.state.slug_banner?this.state.slug_banner:this.state.selectedItem.slug_banner,
            documentId: this.state.selectedItem.documentId?this.state.selectedItem.documentId:'',
            action: this.state.editmode,
            LastUpdatedTimeStamp: dateFormatUtil(),
            UpdatedBy: this.props.user.FullName
                ? this.props.user.FullName
                : 'Admin'
        };
        this.setState({
            pageNumber: this.state.PrevpageNumber,
            StartAt: this.state.PrevStartAt,
            LastDocument: this.state.PrevLastDocument,
            FirstDocument: this.state.PrevFirstDocument
        });
        RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            data,
            'slugs/update-slug'
        )
            .then((response) => response.json())
            .then((responseData) => {
                this.setState({ modalShow: false,selectedItem:data });
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    this.loadData();
                    if (this._isMounted) {
                        this.setState({selectedItem:[]});
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });

    }

    handleClose = () => {
        if (this._isMounted) {
            this.setState({selectedItem:[], modalShow: false ,reportModalShow: false});
        }
    };

    
    
    render() {
        const actions = [
            {
                icon: 'add',
                tooltip: 'Add new',
                position: 'toolbar',
                onClick: () => {
                    if (this._isMounted) {
                        this.setState({oldSlug:'',name:'',monthly_limit:'',weight:0,master_gc:'',slug_banner:'',editmode:'Add',modalShow: true, selectedItem: [] });
                    }
                }
            }
        ];

        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                {!this.state.showGCList && (
                    <div>
                        <Row>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Gift Card Slugs
                            </h4>
                        </Row>
                        <div>
                            <hr />
                        </div>
                        <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    <select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="search_by"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_by}
                                    >
                                        {searchBy.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                Search By {search.key}
                                            </option>
                                        ))}
                                    </select>
                                    
                                    <Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>

                        <MaterialTable
                            components={{
                                Pagination: PatchedPagination
                            }}
                            title="Slugs"
                            columns={[
                                {
                                    title: 'Thumbnail',
                                    field: 'slug_banner',
                                    render: (row) => (
                                        <div className={styles.small_thumbnail}>
                                            {row.slug_banner &&<img src={row.slug_banner} />}
                                        </div>
                                    )
                                },
                                {
                                    title: 'Master Gift Card',
                                    field: 'master_gc',
                                    render: (row) => (
                                        <div>
                                            {row.master_gc}
                                        </div>
                                    )
                                },
                                {
                                    title: 'Slug Name',
                                    field: 'name',
                                    render: (row) => (
                                        <div>
                                            {row.name}
                                        </div>
                                    )
                                },
                                {
                                    title: 'Slug',
                                    field: 'slug',
                                    render: (row) => (
                                        <div>
                                            {row.slug}
                                        </div>
                                    )
                                },
                                
                                {
                                    title: 'Monthly Limit',
                                    field: 'monthly_limit',
                                    render: (row) => (
                                        <div>
                                            {row.monthly_limit}
                                        </div>
                                    )
                                },
                                {
                                    title: 'Weight',
                                    field: 'weight',
                                    render: (row) => (
                                        <div>
                                            {row.weight}
                                        </div>
                                    )
                                },
                                { title: 'Manage Gift Card', field: '',
                                render: (row) => (
                                    <div>
                                        <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={(e) =>
                                            this.listGC(row)
                                        }
                                    >
                                        List
                                    </Button>

                                    
                                    </div>
                                ) },
                                { title: 'Action', field: '',
                                render: (row) => (
                                    <div>
                                        <EditIcon
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={(e) =>
                                                this.updateDetail(row)
                                            }
                                        />
                                        <DeleteIcon
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={(e) =>
                                                this.deleteDetail(row)
                                            }
                                        />
                                        
                                    </div>
                                ) },
                                
                                
                            ]}
                            data={this.state.data}
                            actions={actions}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />

                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.data.length <
                                    this.state.perPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {this.state.data.length >=
                                    this.state.perPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}

                {this.state.showGCList && (
                    <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.hideOffers}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Manage {this.state.selectedRow.name}
                            </h4>
                        </Row>

                        <AllGiftCards Slug={this.state.selectedRow} {...this.props} />
                    </div>
                )}

                <Modal  
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        {this.state.selectedItem.name ?<Modal.Title>{this.state.editmode}  {this.state.selectedItem.name}</Modal.Title>:<Modal.Title>Add New Slug</Modal.Title>}
                    </Modal.Header>

                    <Modal.Body>
                    {this.state.editmode =='Delete' ?<p>
                    Are you sure you want to delete this item?
                    </p>:<div>
                    <Form.Group>
                                <Form.Label>Master Gift Card</Form.Label>
                                {this.state.masterGCList.length>0 &&<select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="master_gc"
                                        onChange={this.onChangeValues}
                                        value={this.state.master_gc}
                                    >
                                        <option
                                                key={'select_master_gc'}
                                                value=''
                                            >
                                                Select Master Gift Card
                                            </option>
                                        {this.state.masterGCList.map((masterGC) => (
                                            <option
                                                key={masterGC.title}
                                                value={masterGC.title}
                                            >
                                                {masterGC.title}
                                            </option>
                                        ))}
                                    </select>}

                                
                    </Form.Group>
                    <Form.Group>
                                <Form.Label>Slug Name</Form.Label>
                                <Form.Control
                                    placeholder="Enter Name"
                                    type="text"
                                    name="name"
                                    value={this.state.name}
                                    onChange={this.onChangeValues}
                                    required
                                />
                    </Form.Group>
                    <Form.Group>
                                <Form.Label>Monthly Limit</Form.Label>
                                <Form.Control
                                    placeholder="Enter Monthly Limit"
                                    type="text"
                                    name="monthly_limit"
                                    value={this.state.monthly_limit}
                                    onChange={this.onChangeValues}
                                    required
                                />
                    </Form.Group>

                    <Form.Group>
                                <Form.Label>Weight</Form.Label>
                                <Form.Control
                                    placeholder="Enter weight"
                                    type="text"
                                    name="weight"
                                    value={this.state.weight}
                                    onChange={this.onChangeValues}
                                    required
                                />
                    </Form.Group>

                    <Form.Group>
                         
                        <div className={styles.thumbnail} >
                        <Form.Label>Thumbnail</Form.Label>
                        {this.state.slug_banner && <img src={this.state.slug_banner}/>}
                        <Tooltip title="Upload Thumbnail">
                            <IconButton aria-label="upload">
                                <label>
                                    <CloudUploadIcon />
                                    <input
                                        type="file"
                                        hidden
                                        onChange={this.handleImageAsFile}
                                    />
                                </label>
                            </IconButton>
                        </Tooltip>
                        </div>
                        </Form.Group>

                    </div>}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.UpdateConfirmed}>
                        {this.state.editmode =='Delete' ?<>Delete</>:<>
                        {this.state.selectedItem.slug ?<>Update</>:<>Add New</>}
                        </>}
                        </Button>
                        
                    </Modal.Footer>
                </Modal>
            </Container>
        );
    }
}

export default AllList;
